export const invoiceLocales = {
  adjustAndResend: "Adjust & Resend",
  invoice: "Invoices",
  historyLog: {
    adminMakePayment:
      "A new version of invoice has been shared by {user}. Action- Payment done by admin user.",
    adminTransactionApproved:
      "A new version of invoice has been shared by {user}. Action - Transaction approved.",
    adminTransactionRejected:
      "A new version of invoice has been shared by {user}. Action - Transaction rejected.",
    cancelInvoice:
      "A new version of invoice has been shared by {user}. Action - Cancelled",
    creditMemoAdjust:
      "A new version of invoice has been shared by {user}. Action - Amount adjusted from Credit Memo.",
    editAndResend:
      "A new version of invoice has been shared by {user}. Action - Edited.",
    invoiceCreated: "A new version of invoice has been created by {user}.",
    invoiceEdited: "{user} has edited this invoice.",
    latePayment:
      "A new version of invoice has been shared by {user}. Action - Resend with late payment charges.",
    normalResend:
      "A new version of invoice has been shared by {user}. Action - Resend.",
    officeTransactionAdd:
      "A new version of invoice has been shared by {user}. Action - Office transaction added.",
    onAccountAdjust:
      "A new version of invoice has been shared by {user}. Action - Amount adjusted from on account.",
    resendCreditMemoAdjust: "{user} adjusted an invoice.",
    resendOnAccountAdjust: "{user} adjusted an invoice.",
    sentInvoice: "A new version of invoice has been shared by {user}.",
    void: "{user} has voided this invoice.",
    invoiceEditedParent: "{user} has edited this invoice - main office.",
  },
  sentInvoice: "Sent invoice",
  createInvoice: "Create invoice",
  creditMemoApplied: "Credit memo applied",
  selectStatus: "Select status",
  officeName: "Office Name",
  invoiceType: "Invoice type",
  id: "Invoice #",
  nameOFOffice: "Office",
  type: "Type",
  billRate: "Bill Rate",
  generatedDate: "Date",
  week: "Week",
  paidAmount: "Paid",
  download: "Download",
  downloadInvoice: "Download invoice",
  dueAmount: "Due",
  status: "Status",
  action: "Action",
  open: "Open",
  overdue: "Over due",
  overdueBy: "Overdue By",
  draft: "Draft",
  paid: "Paid",
  cancelled: "Cancelled",
  cancel: "Cancel",
  next: "Next",
  dateRange: "Date Range",
  from: "From",
  to: "To",
  zipcode: "Zip code",
  state: "State",
  description: "Description",
  pleaseSelectOffice: "Please select office",
  fromDateErrorMsg: "Please enter from date",
  toDateErrorMsg: "Please enter to date",
  pleaseSelectState: "Please select state",
  pleaseEnterZipcode: "Please enter zip code",
  onAccount: "On Account",
  addOnAccount: "Add On Account",
  slNo: "Sl.No",
  officeId: "Office ID#",
  city: "City",
  amount: "Amount",
  enterTheAmount: "Enter the amount(in $)",
  transactionId: "Transaction ID",
  comment: "Comment",
  submit: "Submit",
  updateOnAccount: "Update On Account",
  onAccountAmount: "On Account Amount",
  yes: "Yes",
  totalCost: "Total Cost($)",
  timeValidationMsg: "Please select date range",
  manualInvoiceUpdateMsg: "Manual invoice updated successfully",
  manualInvoiceCreateMsg: "Manual invoice created successfully",
  invoiceTotal: "Invoice Total",
  invoiceAmount: "Invoice Amount",
  manualInvoiceCancelSuccess: "Invoice cancelled successfully",
  cancelWarnMsg: "You are about to cancel manual invoice of",
  no: "No",
  regular: "Auxiliary/Dentist Job",
  payroll: "Payroll",
  referral: "Referral",
  job: "Job",
  role: "Role",
  serviceType: "Service Type",
  placementType: "Placement Type",
  contract: "Contract/Temp",
  conversionHire: "Conversion Hire",
  directHire: "Direct hire",
  hours: "Hours",
  date: "Date",
  amountDue: "Amount due",
  dueDate: "Due date",
  invicePeriod: "Invoice period",
  back: "Back",
  viewJob: "View job",
  totalAmount: "Total Amount",
  amountToPay: "Amount to Pay",
  latePaymentCharges: "SC",
  paymentInfoMsg: "Charges based on delay in payment from invoice pay date",
  weekStartDate: "Week Start Date",
  weekEndDate: "Week End Date",
  markAsPaid: "Mark as paid",
  paymentAmount: "Payment Amount($)",
  paymentType: "Payment Type",
  nameOfProfessional: "Name of Professional",
  billableHours: "Billable Hours",
  invoiceTimesheet: "Invoice - Timesheet",
  officeInvoice: "Office invoice",
  payment: "Payment",
  edit: "Edit",
  adjust: "Adjust",
  manual: "Manual",
  automated: "Automated",
  creditMemo: "Credit Memo",
  paymentMethod: "Payment Method",
  editInvoice: "Edit invoice",
  all: "All",
  onAccountAdded: "On account added",
  deducted: "Deducted",
  selectPlaceHolder: "Select ...",
  onAccountUpdateMsg: "On account updated successfully",
  onAccountCreateMsg: "On account created successfully",
  startDate: "Start Date",
  endDate: "End Date",
  totalBillableHours: "Total billable hours",
  totalPayRate: "Total pay rate",
  markAsPaidSuccessMsg: "Mark as paid successfully",
  markPayment: "Mark Payment",
  amountPaid: "Amount paid",
  creditMemoCreateSuccessMsg: "Credit memo created successfully",
  creditMemoDeductSuccessMsg: "Credit memo deducted successfully",
  updateCreditMemo: "Update Credit Memo",
  addCreditMemo: "+ Add Credit Memo",
  enterInvoiceNumber: "Enter invoice number",
  enterOfficeId: "Enter office id",
  selectWeek: "Select week",
  reset: "Reset",
  search: "Search",
  invoiceId: "Invoice ID",
  officeID: "Office ID",
  addInfo: "Add info",
  pleaseSelect: "Please select",
  deductCreditMemo: "Deduct Credit Memo",
  or: "Or",
  addReason: "Add reason",
  updateAmount: "Update amount",
  deductFromOnAccount: "Deduct from",
  remainingAmount: "Remaining amount",
  processing: "Processing",
  rejected: "Rejected",
  deductOnAccount: "Deduct on Account",
  addPayment: "Add Payment",
  paymentRejected: "Payment rejected",
  paymentApproved: "Payment approved",
  paymentMarkedSuccessMsg: "Payment marked successfully",
  modeOfPayment: "Mode of payment",
  totalInvoiceAmount: "Total Invoice Amount",
  amountPayable: "Amount Payable",
  balanceAmount: "Balance Amount",
  dateOfPayment: "Date of payment",
  total: "Total",
  rejectConfirmMsg: "Are you sure that you want to reject this payment?",
  approveConfirmMsg: "Are you sure that you want to approve this payment?",
  invoiceUpdateMsg: "Invoice updated successfully",
  sentInvoiceSuccessMsg: "Invoice sent successfully",
  enterOfficeName: "Enter office name",
  info: "Info",
  log: "Log",
  creditMemoId: "Credit memo ID",
  creditMemoAddWarnMsg:
    "You are added a credit memo. Are you sure you want to proceed",
  creditMemoDeductWarnMsg:
    "You are deducting a credit memo. Are you sure you want to proceed",
  creditMemoAccount: "Credit memo account",
  creditMemoOf: "Credit Memo of",
  selectOffice: "Select office",
  addAddendum: "Add Addendum",
  addendum: "Addendum",
  releaseContract: "Release contract",
  uploadSignedContract: "Upload signed contract",
  days: "Days",
  nameOfAddendum: "Name of Addendum",
  uploadAddendum: "Upload Addendum",
  saveAndSend: "Save and Send",
  dateWeekErrorMsg: "The selected dates must be within a range of 7 days.",
  approve: "Approve",
  reject: "Reject",
  noOfficeFound: "No offices found",
  paymentDue: "Payment Due",
  view: "View",
  jobRole: "Job Role",
  paymentStatus: "Payment Status",
  notPaid: "Not Paid",
  comments: "Comments",
  daysAfterDueDate: "Days after due date (Days)",
  tagRecruiter: "Tag Recruiter",
  typeInvoice: "Invoice Type",
  range: "Range",
  recruiter: "Recruiter",
  defaultTotalValue: "0.00",
  totalOutstandingAmount: "Total Outstanding Amount",
  professionalName: "Professional Name",
  totalHours: "Total Hours",
  adjustedAmount: "Adjusted Amount",
  history: "History",
  editInvoiceAlertMsg:
    " Please note that upon submission, the updated invoice will be automatically shared with the office.",
  invoiceEditSubAlertMsg:
    "The invoice amount edit would only affect the invoice module and not in the timesheet and other areas.",
  void: "Void",
  invoiceVoidSuccess: "Invoice voided successfully",
  voidWarnMsg:
    "Are you sure you want to void this invoice? It will not be removed from listing, but it will be marked as Void and remain visible for reference.",
  billAmount: "Bill Amount",
  billAmountDesc: "Bill Amount = Hours * bill rate",
  ccText:
    "An additional 3.5% transaction fee will be applied as your selected payment method is Credit Card (CC).",
  resend: "Resend",
  resendMsg:
    "Are you sure you want to resend this invoice? A copy of this will be shared with the ",
  office: "office",
  finalDueAmount: "Final Due Amount",
  resendInvoiceSuccessMsg: "Invoice resend successfully",
  viewPDF: " View PDF ",
  logMessage: "A new version of invoice has been shared by",
  edited: "Edited",
  amountAdjusted: "Amount Adjusted",
  serviceChargeAdded: "Service Charge Added",
  serviceCharges: "Service charges",
  rejectPayment: "Reject payment",
  pleaseSelectModeofPayment: "Please select mode of payment",
  amountWithdrawn: "Amount withdrawn",
  voidInvoice: "Void Invoice",
  invoiceEditMsg: "Invoice edited successfully",
  revisedBillAmount: "Revised Bill Amount",
  memo: "Memo",
  adjustment: "Adjustment",
  parentOffice: "Parent",
  childOffice: "Child",
  editLogNote:
    "Note: the original and new amount shown are office specific and not total invoice amount",
  adjustedFrom: "Adjusted from",
  originalAmount: "Original Amount",
  newAmount: "New Amount",
  jobInfo: "Job Info",
  invoiceJobInfo: "Invoice - Job Info",
  editedAmount: "Edited Amount",
  initialAmount: "Initial Amount",
  paidBy: "Paid By",
  clear: "Clear",
  save: "Save",
  includeTimesheets: "Include Timesheets",
  includeMasterExcel: "Include Master Excel",
  includeAdditionalDocuments:
    "Select if the office would like to receive these additional documents.",
  childSpecific: "Child Specific",
  masterWithChild: "Master with child invoices",
  masterOnly: "Master Only",
  selectInvoicingFormat:
    "Please select the invoicing format preferred by the office.",
};
